import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kh-banner',
  styleUrls: ['./banner.component.less'],
  templateUrl: './banner.component.html',
  standalone: false
})
export class BannerComponent implements OnInit {
  public visible = true;

  public constructor() { }

  public ngOnInit(): void {
  }

  public toggleVisibility(): void {
    this.visible = !this.visible;
  }
}
